import { render, staticRenderFns } from "./CourseRequestList.vue?vue&type=template&id=4a18ec52"
import script from "../../services/student/course-request-list.js?vue&type=script&lang=js&external"
export * from "../../services/student/course-request-list.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports